/* tslint:disable */
/* eslint-disable */
/**
 * Mark As Already Had Appointment
 * Mark As Already Had Appointment
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkAsAlreadyHadAppointmentRequest
 */
export interface MarkAsAlreadyHadAppointmentRequest {
    /**
     * First name and last name of Job Manager
     * @type {string}
     * @memberof MarkAsAlreadyHadAppointmentRequest
     */
    fullName: string;
    /**
     * Name of the function job managers have when they are part of this campaign.
     * @type {string}
     * @memberof MarkAsAlreadyHadAppointmentRequest
     */
    contactsFunction: string;
    /**
     * E-mail address of Job Manager
     * @type {string}
     * @memberof MarkAsAlreadyHadAppointmentRequest
     */
    emailAddress: string;
}

export function MarkAsAlreadyHadAppointmentRequestFromJSON(json: any): MarkAsAlreadyHadAppointmentRequest {
    return MarkAsAlreadyHadAppointmentRequestFromJSONTyped(json, false);
}

export function MarkAsAlreadyHadAppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkAsAlreadyHadAppointmentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fullName': json['fullName'],
        'contactsFunction': json['contactsFunction'],
        'emailAddress': json['emailAddress'],
    };
}

export function MarkAsAlreadyHadAppointmentRequestToJSON(value?: MarkAsAlreadyHadAppointmentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fullName': value.fullName,
        'contactsFunction': value.contactsFunction,
        'emailAddress': value.emailAddress,
    };
}

